import React, { FC } from 'react'
import FormHelperText from '@mui/material/FormHelperText'

interface HelperTextProps {
  helperText: string | undefined,
  error: boolean | undefined,
  touched: boolean | undefined,
}

const HelperText: FC<React.PropsWithChildren<HelperTextProps>> = ({
  helperText,
  error,
  touched,
}) => {
  if(!error && !helperText) return null

  const hasError = touched && error ? true : false

  return (  
    <FormHelperText
      error={ hasError }
    >
      { helperText }
    </FormHelperText>
  )
}

export default HelperText